import { Spinner } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './SearchResults.css';

interface ISearchResultsProps {
  url: string;
  loading: boolean;
  onFrameLoadStart: () => void;
  onFrameLoadEnd: () => void;
}

export const SearchResults: React.FC<ISearchResultsProps> = ({ url, loading, onFrameLoadStart, onFrameLoadEnd }) => {
  const iframe = React.useRef<HTMLIFrameElement>(null);

  React.useEffect(() => {
    if (iframe.current && iframe.current.contentWindow) {
      onFrameLoadStart();
      const normalizedUrl = url || 'about:blank';
      iframe.current.contentWindow.location.replace(normalizedUrl);
    }
  }, [url, onFrameLoadStart]);

  return (
    <div className={styles['container']}>
      <div className={styles['loader-wrapper']}>
        <Spinner />
      </div>
      <iframe
        ref={iframe}
        className={classNames(styles['iframe'], loading && styles['loading'])}
        onLoad={onFrameLoadEnd}
        frameBorder="0"
      />
    </div>
  );
};
